import { render, staticRenderFns } from "./GroupFooter.vue?vue&type=template&id=5d4c2abf&scoped=true"
var script = {}
import style0 from "@/assets/css/group_dashboard/group_footer.css?vue&type=style&index=0&id=5d4c2abf&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c2abf",
  null
  
)

export default component.exports